import React from "react"
import PropTypes from "prop-types"
import { Button } from "antd"

const TabPill = ({ active, onClick, className, activeClassName, inactiveClassName, children }) => (
  <Button type="text" className={`${className} ${active ? activeClassName : inactiveClassName}`} onClick={onClick}>
    {children}
  </Button>
)

TabPill.propTypes = {
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  activeClassName: PropTypes.string.isRequired,
  inactiveClassName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

export default TabPill
